import React from 'react'
import { Line } from 'react-chartjs-2'
import { Col, Row, Typography } from 'antd'

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Tooltip,
    Legend,
    } from 'chart.js';
    
    

const { Title } = Typography

const LineChart = ({coinHistory, currentPrice, coinName}) => {
    const coinPrice = [];
    const coinTimeStamp = [];
    ChartJS.register(
        CategoryScale,
        LinearScale,
        PointElement,
        LineElement,
        Tooltip,
        Legend
    );

    for(let i =0;i<coinHistory?.data?.history?.length; i += 1){
        coinPrice.push(coinHistory.data.history[i].price)
        // coinTimeStamp.push(new Date(coinHistory.data.history[i].timestamp).toLocaleDateString())
    }
    for(let i =0;i<coinHistory?.data?.history?.length; i += 1){
        // coinPrice.push(coinHistory.data.history[i].price)
        coinTimeStamp.push(new Date(coinHistory.data.history[i].timestamp).toLocaleDateString())
    }

    const data = {
        labels: coinTimeStamp,
        datasets : [
            {
                label: "Price in USD",
                data: coinPrice,
                fill: false,
                backgroundColor: "#0071bd",
                borderColor : '#0071bd'
            }
        ]
    }

    const options = {
        scale : {
            yAxes : [
                {
                    ticks: {
                        beginAtZero : true
                    }
                }
            ]}
        }




  return (
    <>
        <Row className='chart-header'>
            <Title level={2} className="chart-title">{coinName} Price chart</Title>
            <Col className='price-container'>
                <Title className='price-change' level={5}>
                    {coinHistory?.data?.change}%
                </Title>
                <Title className='current-price' level={5}>
                    Current {coinName} Price: $ {currentPrice}
                </Title>
            </Col>
        </Row>
        <Line data={data} options={options} />

    </>
  )
}

export default LineChart